export default "__VITE_ASSET__DEj_gdmk__"